/* eslint-disable no-param-reassign */

const initialState = () => ({
  amount: {
    reviews: 0,
    questions: 0,
  },
  unresolved: {
    reviews: 0,
    questions: 0,
  },
  unapproved: {
    reviews: 0,
    questions: 0,
  },
  searchTerm: '',
  isFetching: false, // any other action
  userIsModerator: false,
  dealsBoughtAndPlusFilterExperiment: '',
  activeTab: 'questions',
});

export { initialState as state };

export const getters = {
  reviewsAmount: (state) => state.amount.reviews,
  questionsAmount: (state) => state.amount.questions,
  unresolvedReviews: (state) => state.unresolved.reviews,
  unresolvedQuestions: (state) => state.unresolved.questions,
  unapprovedReviews: (state) => state.unapproved.reviews,
  unapprovedQuestions: (state) => state.unapproved.questions,
  searchTerm: (state) => state.searchTerm,
  // eslint-disable-next-line no-shadow
  searchAmount(state, getters) {
    if (!state.searchTerm) {
      return 0;
    }

    return getters.reviewsAmount + getters.questionsAmount;
  },
  isFetching: (state) => state.isFetching,
  userIsModerator: (state) => state.userIsModerator,
  isdealsBoughtAndPlusFilterEnabled: (state) => state.dealsBoughtAndPlusFilterExperiment === 'enabled',
  activeTab: (state) => state.activeTab,
};

export const mutations = {
  setAmount(state, data) {
    state.amount = data;
  },

  setUnresolved(state, data) {
    state.unresolved = data;
  },

  setUnApproved(state, data) {
    state.unapproved = data;
  },

  setSerchTerm(state, text) {
    state.searchTerm = text;
  },

  setIsFetching(state, value) {
    state.isFetching = value;
  },

  setUserIsModerator(state, value) {
    state.userIsModerator = value;
  },

  setDealsBoughtAndPlusFilterExperiment(state, value) {
    state.dealsBoughtAndPlusFilterExperiment = value;
  },

  setActiveTab(state, tab) {
    state.activeTab = tab;
  },
};

export const actions = {
  setQuestionsAmount({ commit, state }, amount) {
    const newAmount = {
      ...state.amount,
      questions: amount,
    };

    commit('setAmount', newAmount);
  },

  setReviewsAmount({ commit, state }, amount) {
    const newAmount = {
      ...state.amount,
      reviews: amount,
    };

    commit('setAmount', newAmount);
  },

  setUnresolvedQuestions({ commit, state }, amount) {
    const unresolved = {
      ...state.unresolved,
      questions: amount,
    };

    commit('setUnApproved', unresolved);
  },

  setUnresolvedReviews({ commit, state }, amount) {
    const unresolved = {
      ...state.unresolved,
      reviews: amount,
    };

    commit('setUnApproved', unresolved);
  },

  setUnapprovedQuestions({ commit, state }, amount) {
    const unapproved = {
      ...state.unapproved,
      questions: amount,
    };

    commit('setUnApproved', unapproved);
  },

  setUnapprovedReviews({ commit, state }, amount) {
    const unapproved = {
      ...state.unapproved,
      reviews: amount,
    };

    commit('setUnApproved', unapproved);
  },

  setSerchTerm({ commit }, text) {
    commit('setSerchTerm', text);
  },

  setIsFetching({ commit }, value) {
    commit('setIsFetching', value);
  },

  setUserIsModerator({ commit }, value) {
    commit('setUserIsModerator', value);
  },

  setDealsBoughtAndPlusFilterExperiment({ commit }, value) {
    commit('setDealsBoughtAndPlusFilterExperiment', value);
  },

  setActiveTab({ commit }, tab) {
    if (tab.indexOf('#') > -1) {
      tab = tab.replace('#', '');
    }

    commit('setActiveTab', tab);
  },
};
